exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n    display: inline-block;\n    position: relative;\n    padding: 1px;\n    outline: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    cursor: pointer;\n    z-index: 0;\n    line-height: 1;\n\n    width: 26px;\n    height: 26px;\n\n    box-sizing: border-box !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/polymer/paper-icon-button/paper-icon-button.component.css
// module id = ./src/app/components/polymer/paper-icon-button/paper-icon-button.component.css
// module chunks = main